import Vue from "vue";
import {
  InteractionStatus,
  PublicClientApplication,
} from "@azure/msal-browser";
import { reactive } from "@vue/composition-api";

export function msalPlugin(
  vue: typeof Vue,
  msalInstance: PublicClientApplication
): void {
  const inProgress = InteractionStatus.Startup;
  const accounts = msalInstance.getAllAccounts();
  const state = reactive({
    instance: msalInstance,
    inProgress: inProgress,
    accounts: accounts,
  });
  vue.prototype.$msal = state;
}
